import { jsx as r, Fragment as d } from "react/jsx-runtime";
import { useState as s } from "react";
import A from "../../hooks/useGetUpcoming.js";
import { AirDateFormatter as c } from "../AirDateFormatter/AirDateFormatter.js";
import { StringList as b } from "../StringList/StringList.js";
import { convert12to24 as h } from "../../utils/helpers.js";
const N = (i) => {
  let n;
  for (let t = 0; t < i.title_code.length; t++)
    if (!isNaN(Number.parseInt(i.title_code.charAt(t), 10))) {
      n = t;
      break;
    }
  return i.title_code.slice(n);
};
function v({
  programId: i,
  programType: n = "series",
  separatorType: t = "pipe",
  includeEpisode: m = !1,
  SCHEDULE_ENDPOINT: _,
  NETWORK: u
}) {
  const [a, S] = s(null), [$, x] = s(null);
  return A({ programId: i, programType: n, SCHEDULE_ENDPOINT: _, NETWORK: u }).then((e) => {
    var p, f;
    let l = null, o = null;
    e.length && (l = `${e[0].start_date_parse} ${h(e[0].start_time)}`, m && ((p = e[0]) != null && p.episode_number ? o = `${(f = e[0]) == null ? void 0 : f.episode_number}: ${e[0].title_name}` : o = `${N(e[0])}: ${e[0].title_name}`)), S(l), x(o);
  }), a === null ? /* @__PURE__ */ r(d, {}) : i === "" ? /* @__PURE__ */ r(d, {}) : m ? /* @__PURE__ */ r(
    b,
    {
      list: [/* @__PURE__ */ r(c, { airdateStr: a, separatorType: t }), $],
      separatorType: "pipe"
    }
  ) : /* @__PURE__ */ r(c, { airdateStr: a, separatorType: t });
}
export {
  v as GetAirdateWrapper,
  v as default
};
